import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const buyers = [{
  name: 'María L.',
  location: 'Ciudad de México',
  time: 'Hace 2 minutos'
}, {
  name: 'Camila R.',
  location: 'Buenos Aires',
  time: 'Hace 5 minutos'
}, {
  name: 'Valentina G.',
  location: 'Bogotá',
  time: 'Hace 8 minutos'
}, {
  name: 'Sofía M.',
  location: 'Lima',
  time: 'Hace 12 minutos'
}, {
  name: 'Isabella P.',
  location: 'Santiago',
  time: 'Hace 15 minutos'
}, {
  name: 'Lucía T.',
  location: 'Madrid',
  time: 'Hace 18 minutos'
}, {
  name: 'Andrea F.',
  location: 'Monterrey',
  time: 'Hace 22 minutos'
}, {
  name: 'Carolina S.',
  location: 'Medellín',
  time: 'Hace 25 minutos'
}, {
  name: 'Daniela V.',
  location: 'Quito',
  time: 'Hace 30 minutos'
}, {
  name: 'Paula H.',
  location: 'Guadalajara',
  time: 'Hace 35 minutos'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const showNotification = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % buyers.length);
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  }, []);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 10000);
    const interval = setInterval(() => {
      showNotification();
    }, 35000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [showNotification]);
  const buyer = buyers[currentIndex];
  return <AnimatePresence data-id="element-351">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 80,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 80
    }} transition={{
      duration: 0.4,
      ease: [0.21, 0.47, 0.32, 0.98]
    }} className="fixed bottom-4 left-4 md:bottom-6 md:left-6 z-50 max-w-[320px]" data-id="element-352">
          <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-start gap-3 relative" data-id="element-353">
            <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-gray-300 hover:text-gray-500 transition-colors" aria-label="Cerrar" data-id="element-354">
              <XIcon className="w-3.5 h-3.5" data-id="element-355" />
            </button>

            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-356">
              <ShoppingBagIcon className="w-5 h-5 text-gold-dark" data-id="element-357" />
            </div>

            <div className="pr-4" data-id="element-358">
              <p className="text-sm font-medium text-gray-900 leading-snug" data-id="element-359">
                <span className="font-bold" data-id="element-360">{buyer.name}</span> de{' '}
                {buyer.location}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-361">
                compró la Guía del Sueño del Bebé
              </p>
              <p className="text-[10px] text-gray-400 mt-1" data-id="element-362">{buyer.time}</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}